import React from 'react';

import PropTypes from 'prop-types';

import AssigneeFilters from './assignee';
import RequiredFilter from './required';
import StatusFilter from './status';

export default function Filters({ showRequiredFilter }) {
  return (
    <div className="d-flex justify-content-end gap-2 align-items-center">
      { showRequiredFilter && <RequiredFilter/> }
      <AssigneeFilters/>
      <StatusFilter/>
    </div>
  );
}

Filters.propTypes = {
  showRequiredFilter: PropTypes.bool,
};
